import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import SelectField from "../inputs/SelectField";
import { payoutOption } from "../../config/data";
import { submitPayout } from "../../store/actions/disbursement/submitPayout";
import SelectMember from "./SelectMember";
import {
  manualPayoutSchema,
  payoutSchema,
  realEstatePayoutSchema,
} from "../../Helper/validationSchemas";
import { useParams } from "react-router-dom";
import HalDatePicker from "../inputs/HalDatePicker";
import CustomInput from "../inputs/CustomInput";
import { submitRealEstatePayout } from "../../store/actions/disbursement/submitRealEstatePayout";
import { getServerDate } from "../../config/dateformatter";
import { submitManualPayout } from "../../store/actions/disbursement/submitManualPayout";
import { getRealEstatePayoutHistory } from "../../store/actions/investment/getRealEstatePayoutHistory";
import { submitProportionalPayout } from "../../store/actions/disbursement/submitProportionalPayout";

function PayoutModal({
  open,
  type,
  onClose,
  cycle,
  refresh,
  selectedRow,
  setButtonText,
  invID,
  setOpenModal,
  cycle_id,
  currency,
}) {
  const { id: investmentId } = useParams();
  const [showMembers, setShowMembers] = useState(false);
  const loading = useSelector((state) => state?.disbursement?.pending);
  const investment = useSelector((state) => state?.investment?.investment);
  const expected_dates =
    cycle?.paymentSchedules?.expected_date ||
    investment?.paymentSchedules?.expected_date ||
    [];
  const paymentSchedules = expected_dates?.map((item, index) => ({
    ...item,
    roi: Number(investment?.roi).toFixed(0) + "%",
    installment: "Payout " + (+index + 1),
    value: item?.id,
    label:
      "Payout " +
      (+index + 1) +
      " (" +
      new Date(item?.date).toDateString() +
      ")",
  }));
  // .filter((item) => item.status !== "Paid");

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    let data = {};
    if (cycle) {
      data.cycle_id = cycle?.id;
      data.investment_product_id = cycle?.investment_id;
    }

    if (selectedRow?.id) {
      dispatch(
        submitPayout({
          ...data,
          beneficiaries: [selectedRow?.id],
          callback: () => {
            form.setSubmitting(false);
            setOpenModal(false);
          },
          fail: () => {
            form.setSubmitting(false);
          },
        }),
      );
    } else if (values?.beneficiary?.value === "all") {
      const beneficiaries = (
        cycle?.investors ||
        investment?.investments ||
        investment?.investors?.map((investor) => ({
          ...investor,
          user_id: investor?.id,
        }))
      )?.map((item) => item?.user_id);

      if (type === "Manual") {
        dispatch(
          submitManualPayout({
            data: {
              cycle_id: cycle?.id,
              investment_product_id: cycle?.investment_id,
              disbursement_date: getServerDate(form?.values?.disbursement_date),
              profit_amount: form?.values?.profit_amount,
              beneficiaries,
            },
            callback: () => {
              form.setSubmitting(false);
              dispatch(
                getRealEstatePayoutHistory({
                  id: invID,
                  callback: () => {},
                  fail: () => {},
                }),
              );

              setOpenModal(false);
            },
            fail: () => {
              form.setSubmitting(false);
            },
          }),
        );
      } else if (type === "Real Estate") {
        dispatch(
          submitRealEstatePayout({
            data: {
              property_product_id: invID,
              disbursement_date: getServerDate(form?.values?.disbursement_date),
              profit_amount: form?.values?.profit_amount,
              repayment_type: form?.values?.repayment_type?.value,
              capital_amount: form?.values?.capital_amount,
              beneficiaries,
            },
            callback: () => {
              form.setSubmitting(false);
              dispatch(
                getRealEstatePayoutHistory({
                  id: invID,
                  callback: () => {},
                  fail: () => {},
                }),
              );
              setOpenModal(false);
            },
            fail: () => {
              form.setSubmitting(false);
            },
          }),
        );
      } else if (
        form?.values?.repayment_type?.value &&
        form?.values?.payout_type?.value
      ) {
        dispatch(
          submitProportionalPayout({
            data: {
              repayment_type: form?.values?.repayment_type?.value,
              payout_type: form?.values?.payout_type?.value,
              amount_to_disburse: form?.values?.amount_to_disburse,
              // payment_schedule_id:
              //   form?.values?.paymentSchedulesValue ||
              //   form?.values?.paymentSchedules?.id,
              beneficiaries,
              expected_date_id: form?.values?.paymentSchedules?.value,
              ...data,
            },
            callback: () => {
              refresh();
              setOpenModal(false);
              form.setSubmitting(false);
            },
            fail: () => {
              form.setSubmitting(false);
            },
          }),
        );
      } else {
        dispatch(
          submitPayout({
            data: {
              payment_schedule_id:
                form?.values?.paymentSchedulesValue ||
                form?.values?.paymentSchedules?.id,
              beneficiaries,
              expected_date_id: form?.values?.paymentSchedules?.value,
              ...data,
            },
            callback: () => {
              refresh();
              setOpenModal(false);
              form.setSubmitting(false);
            },
            fail: () => {
              form.setSubmitting(false);
            },
          }),
        );
      }
    } else {
      setShowMembers(true);
    }
  };
  const handleSubmitManualDisbursement = (values) => {
    let beneficiaries = [];
    const data = {
      disbursement_date: getServerDate(values?.disbursement_date),
      profit_amount: values?.profit_amount,
    };

    if (
      investment?.investment_category?.name?.toLowerCase() === "real estate"
    ) {
      data.property_product_id = invID;
      data.repayment_type = form?.values?.repayment_type?.value;
      data.capital_amount = form?.values?.capital_amount;
    } else if (invID && cycle_id) {
      data.cycle_id = cycle_id;
      data.investment_product_id = invID;
    } else {
      data.property_product_id = invID;
    }

    if (selectedRow?.id) {
      dispatch(
        submitRealEstatePayout({
          data: {
            ...data,
            beneficiaries: [selectedRow?.id],
          },
          callback: () => {
            form.setSubmitting(false);
            setOpenModal(false);
          },
          fail: () => {
            form.setSubmitting(false);
          },
        }),
      );
    } else if (values?.beneficiary?.value === "all") {
      beneficiaries = (
        cycle?.investors ||
        investment?.investments ||
        investment?.investors?.map((investor) => ({
          ...investor,
          user_id: investor?.id,
        }))
      )?.map((item) => item?.user_id);
      dispatch(
        submitRealEstatePayout({
          data: {
            ...data,
            beneficiaries,
          },
          callback: () => {
            form.setSubmitting(false);
            setOpenModal(false);
          },
          fail: () => {
            form.setSubmitting(false);
          },
        }),
      );
    } else {
      setShowMembers(true);
    }
  };

  const form = useFormik({
    initialValues: {
      beneficiary: {
        value: "selected_users",
        label: "Selected Users",
      },
      amount_to_disburse: 0,
      currency: { value: currency, label: currency },
      paymentSchedules: paymentSchedules[0],
      investment_product_id: investmentId,
    },
    onSubmit:
      type === "Manual" || type === "Real Estate"
        ? handleSubmitManualDisbursement
        : handleSubmit,
    validationSchema: selectedRow?.id
      ? manualPayoutSchema
      : type === "Manual" || type === "Real Estate"
        ? realEstatePayoutSchema
        : payoutSchema,
  });

  useEffect(() => {
    form.setFieldValue("currency", { value: currency, label: currency });
  }, [currency]);

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="custom-modal-title"
        aria-describedby="custom-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 2,
          }}
        >
          <IconButton
            aria-label="close"
            sx={{
              position: "absolute",
              top: 19,
              right: 10,
            }}
            onClick={onClose}
          >
            <ClearIcon />
          </IconButton>

          <div className="w-full p-5">
            <div>
              {selectedRow?.id ? (
                <h1 className="font-[500] text-2xl mb-4">{`Make manual payout to ${selectedRow?.firstName}`}</h1>
              ) : (
                <h1 className="font-[500] text-2xl mb-4">Payout</h1>
              )}
              {/* <p className="text-sm mb-8 w-[432px]">
                Are you sure you want to make this payout
              </p> */}
              <div className=" w-full items-center mr-4">
                {type === "Real Estate" ? (
                  <>
                    <div className="mb-4 lg:mb:0 lg:pl-0 lg:mr-8 w-full">
                      <p className="">Capital amount</p>
                      <CustomInput
                        id="capital_amount"
                        width="100%"
                        form={form}
                        type="currency"
                        placeholder={"Enter Amount"}
                        height="12px"
                        mt="10"
                        mb="2px"
                        mr="10px"
                        borderRadius={"4px"}
                        className="mobile-input-width"
                      />
                    </div>

                    <label>Repayment Type</label>
                    <div className="mb-4">
                      <SelectField
                        id="repayment_type"
                        options={[
                          {
                            label: "Profit + Capital",
                            value: "profit_capital",
                          },
                          {
                            label: "Profit Only",
                            value: "profit_only",
                          },
                          {
                            label: "Capital Only",
                            value: "capital_only",
                          },
                        ]}
                        form={form}
                        sx={{
                          width: "432px",
                          height: "48px",
                          borderRadius: "7px",
                          borderColor: "#D0D5DD",
                          color: "#101828",
                        }}
                        fw={400}
                        fz={"16px"}
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {type === "Manual" || type === "Real Estate" ? (
                  <>
                    <div className="mb-4 lg:mb:0   ">
                      <label>Payout date</label>

                      <HalDatePicker
                        type={2}
                        label="Payout Date"
                        id={"disbursement_date"}
                        disablePast={true}
                        form={form}
                        small
                        rightImage
                        className="-mr-5"
                      />
                    </div>

                    <div className="mb-4 lg:mb:0 lg:pl-0 lg:mr-8 w-full">
                      <p className="">Profit amount</p>
                      <CustomInput
                        id="profit_amount"
                        width="100%"
                        form={form}
                        type="currency"
                        placeholder={"Enter Amount"}
                        height="12px"
                        mt="10"
                        mb="2px"
                        mr="10px"
                        borderRadius={"4px"}
                        className="mobile-input-width"
                      />
                    </div>
                  </>
                ) : (
                  <div className="mt-4">
                    <label>Select Schedule</label>
                    <div className="mb-4">
                      <SelectField
                        id="paymentSchedules"
                        options={paymentSchedules}
                        form={form}
                        sx={{
                          width: "432px",
                          height: "48px",
                          borderRadius: "7px",
                          borderColor: "#D0D5DD",
                          color: "#101828",
                        }}
                        fw={400}
                        fz={"16px"}
                      />
                    </div>

                    {type === "FROM-SCHEDULE" ? (
                      <>
                        <label>Repayment Type</label>
                        <div className="mb-4">
                          <SelectField
                            id="repayment_type"
                            options={[
                              {
                                label: "Profit + Capital",
                                value: "profit_capital",
                              },
                              {
                                label: "Profit Only",
                                value: "profit_only",
                              },
                              {
                                label: "Capital Only",
                                value: "capital_only",
                              },
                            ]}
                            form={form}
                            sx={{
                              width: "432px",
                              height: "48px",
                              borderRadius: "7px",
                              borderColor: "#D0D5DD",
                              color: "#101828",
                            }}
                            fw={400}
                            fz={"16px"}
                          />
                        </div>
                        <label>Payout Type</label>
                        <div className="mb-4">
                          <SelectField
                            id="payout_type"
                            options={[
                              {
                                label: "Full",
                                value: "full",
                              },
                              {
                                label: "Partial",
                                value: "partial",
                              },
                            ]}
                            form={form}
                            sx={{
                              width: "432px",
                              height: "48px",
                              borderRadius: "7px",
                              borderColor: "#D0D5DD",
                              color: "#101828",
                            }}
                            fw={400}
                            fz={"16px"}
                          />
                        </div>
                        {/* {form.values.payout_type?.value === "partial" ? (
                          <> */}
                        <label className="text-sm font-[600] text-[#344054]">
                          Amount to Pay
                        </label>
                        <div className="w-full mb-4">
                          <CustomInput
                            // width="400px"
                            fullWidth
                            height="18px"
                            id="amount_to_disburse"
                            type={"currency"}
                            form={form}
                            placeholder={"Enter Amount"}
                            borderColor="#D0D5DD"
                            mt="10px"
                            pt="28px"
                          />
                        </div>
                        {/* </>
                        ) : (
                          <></>
                        )} */}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                )}

                {selectedRow?.id ? (
                  <></>
                ) : (
                  <div className="mt-6">
                    <label>Payout To</label>
                    <div className="mb-4">
                      <SelectField
                        id="beneficiary"
                        options={payoutOption}
                        form={form}
                        sx={{
                          width: "432px",
                          height: "48px",
                          borderRadius: "7px",
                          borderColor: "#D0D5DD",
                          color: "#101828",
                        }}
                        fw={400}
                        fz={"16px"}
                      />
                    </div>
                  </div>
                )}

                <div className="flex mt-10 w-full items-center">
                  <CustomButton
                    variant="outlined"
                    customColor="#fff"
                    children="Cancel"
                    width="100%"
                    onClick={onClose}
                    height="50px"
                    borderColor="#D0D5DD"
                    margin="0px 25px 0px 0px"
                    color="#159AA8"
                    iconWidth="22px"
                  />

                  <CustomButton
                    variant="contained"
                    customColor="#159AA8"
                    loading={loading || form.isSubmitting}
                    children={
                      form?.values?.beneficiary?.value === "selected_users"
                        ? "Continue"
                        : "Submit"
                    }
                    width="100%"
                    height="50px"
                    padding="10px"
                    disabled={
                      !form?.isValid || loading
                      // ||
                      // (type === "FROM-SCHEDULE" &&
                      //   form.values.payout_type?.value === "partial" &&
                      //   form.values.amount_to_disburse < 10)
                    }
                    onClick={form.handleSubmit}
                  />
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <SelectMember
        open={showMembers}
        type={type}
        invID={invID}
        form={form}
        refresh={refresh}
        cycle={cycle}
        percentage={form?.values?.disburse_perc}
        onCloseParent={onClose}
        onClose={() => setShowMembers(false)}
      />
    </>
  );
}

export default PayoutModal;
